import { Hr, Info, PageSectionPrimary } from 'ui/components'
import { Col } from 'ui/themes/globalStyles'

import { ReviewFormUploadWrap } from '../ApplicationControls/components'
import { ReviewsProps } from './ReviewsProps'

import { s } from './styles'

export const Reviews = ({ application }: ReviewsProps) => {
  if (!application.reviews) {
    return null
  }

  const { credit, compliance, martinHood } = application.reviews

  return (
    <PageSectionPrimary title="Reviews" anchor="review" face="solid">
      <s.Wrapper>
        <div>
          <Col>
            <Info label="Compliance Review">
              {compliance.isDone ? compliance.notes : 'No review has been submitted here yet.'}
            </Info>
            {compliance.isModifiable && (
              <ReviewFormUploadWrap
                application={application}
                title="Add the Compliance Review"
                onlyNotes={true}
                requiredNotes={false}
                notes={application.reviews?.compliance?.notes || ''}
                buttonName="Edit Review"
                fieldName="internalReviewCompliance"
              />
            )}
          </Col>
          <Hr thin />
        </div>

        <div>
          <Col>
            <Info label="Martin Hood, CPA Review">
              {martinHood.isDone ? martinHood.notes : 'No review has been submitted here yet.'}
            </Info>
            {martinHood.isModifiable && (
              <ReviewFormUploadWrap
                application={application}
                title="Add the Martin Hood Review"
                type="Martin Hood Review"
                onlyNotes={false}
                requiredNotes={true}
                notes={application.reviews?.martinHood?.notes || ''}
                buttonName="Add Review"
                fieldName="internalReviewMartinHood"
              />
            )}
          </Col>
          <Hr thin />
        </div>
        <div>
          <Col>
            <Info label="Credit Review">{credit.isDone ? credit.notes : 'No review has been submitted here yet.'}</Info>
            {credit.isModifiable && (
              <ReviewFormUploadWrap
                application={application}
                title="Add the Credit Review"
                type="Credit Review"
                onlyNotes={false}
                requiredNotes={true}
                notes={application.reviews?.credit?.notes || ''}
                buttonName="Add Review"
                fieldName="internalReviewCredit"
              />
            )}
          </Col>
        </div>
      </s.Wrapper>
    </PageSectionPrimary>
  )
}
